module.exports = __webpack_public_path__ + "img/JalaHarvest.e61b347b.svg";